import { Component, Inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cancel-case-dialog',
  templateUrl: './cancel-case-dialog.component.html',
  styleUrls: ['./cancel-case-dialog.component.scss'],
})
export class CancelCaseDialogComponent {
  cancelForm: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<CancelCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder
  ) {
    this.cancelForm = this.fb.group({
      notes: ['', [Validators.required, Validators.pattern(/\S+/)]],
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.cancelForm.valid) {
      this.dialogRef.close({ notes: this.cancelForm.value.notes });
    }
  }
}
